
import { computed, defineComponent, PropType, reactive } from 'vue'

export enum ButtonRackDirectionType {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export default defineComponent({
  name: 'ButtonRack',
  props: {
    direction: {
      type: String as PropType<ButtonRackDirectionType>,
      require: true,
    },
  },
  setup(props) {
    const state = reactive({
      classes: computed(() => ({
        ButtonRack: true,
        'ButtonRack--horizontal': props.direction === ButtonRackDirectionType.HORIZONTAL,
        'ButtonRack--vertical': props.direction === ButtonRackDirectionType.VERTICAL,
      })),
    })

    return state
  },
})
